var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout-wrapper"},[(_vm.$auth.user)?_c('navbar'):_vm._e(),_vm._v(" "),_c('main',{staticClass:"flex"},[(_vm.$auth.user)?_c('sidebar'):_vm._e(),_vm._v(" "),_c('nuxt')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }